/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, days: NonNullable<unknown> }} Bulk_Delete_Confirm_Artifacts_Description_TrashInputs */



/**
* | output |
* | --- |
* | "Delete {count} app(s)? They move to the trash, where you can restore them for {days} days. Their share links and custom domains are switched off immediately ..." |
*
* @param {Bulk_Delete_Confirm_Artifacts_Description_TrashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bulk_delete_confirm_artifacts_description_trash = /** @type {((inputs: Bulk_Delete_Confirm_Artifacts_Description_TrashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bulk_Delete_Confirm_Artifacts_Description_TrashInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} App(s) löschen? Sie wandern in den Papierkorb und lassen sich dort ${i?.days} Tage lang wiederherstellen. Ihre Freigabelinks und eigenen Domains werden sofort abgeschaltet und bleiben auch nach dem Wiederherstellen aus.`)
	return /** @type {LocalizedString} */ (`Delete ${i?.count} app(s)? They move to the trash, where you can restore them for ${i?.days} days. Their share links and custom domains are switched off immediately and stay off after a restore.`)
});